// @flow

import React, { type Node, useMemo } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Button } from '@tectonics/look-and-feel/shopify-embedded/atoms';

export function ButtonSaveVoucher(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const gatewayVoucherUrl = getGatewayVoucherUrl(incomingPayment);

  const href = useMemo(() => {
    const url = new URL(gatewayVoucherUrl);
    url.searchParams.append('format', 'pdf');
    return url.toString();
  }, [gatewayVoucherUrl]);

  return (
    <Button
      as="a"
      block
      flat
      href={href}
      outline
      rel="noopener noreferrer"
      size="lg"
      target="_blank"
      type="primary"
      style={buttonStyle}
    >
      Guardar Recibo Efecty en PDF
    </Button>
  );
}

const buttonStyle = {
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontSize: '12px',
  color: 'rgb(35, 151, 212)',
  background: 'white',
  padding: '8px 2px',
  marginTop: '2px',
  height: '21px',
};
